import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams } from 'react-router-dom';
import { LuUpload } from "react-icons/lu";
import { AiOutlineClose } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Admin/Header';
import Sidebar from '../components/Admin/Sidebar';
import { $host } from "../http";

const CourseEditPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [imageFile, setImageFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [subject, setSubject] = useState(null);
  const [teachers, setTeachers] = useState([]); // Состояние для списка преподавателей
  const [currentCourse, setCurrentCourse] = useState({
    title: '',
    description: '',
    image_url: '',
    video_preview_url: '',
    price: '',
    subject: '',
    teacher_id: '',
    curators: [],
  });

  const [errors, setErrors] = useState({
    title: '',
    description: '',
    image: '',
    price: '',
  });
  
  const [isPriceApplied, setIsPriceApplied] = useState(false);



  const [selectedTeacher, setSelectedTeacher] = useState(null); // Состояние для выбранного преподавателя
  const [isTeacherModalOpen, setTeacherIsModalOpen] = useState(false); // Состояние для управления модальным окном
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTeachers, setFilteredTeachers] = useState([]); // Состояние для хранения отфильтрованных преподавателей

  const handleTeacherSelection = (teacher) => {
    setSelectedTeacher(teacher); // Устанавливаем выбранного преподавателя
    setTeacherIsModalOpen(false); // Закрываем модальное окно
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const {data} = await $host.get(`/api/public/subjects`);
        
        // Найти предмет, связанный с текущим курсом
        const foundSubject = data.find(subject => subject.courses.includes(currentCourse.id));
        
        if (foundSubject) {
          setSubject(foundSubject);
        } else {
          console.log('Предмет не найден для текущего курса');
        }
      } catch (error) {
        console.log('Ошибка при получении предметов');
      }
    };

    fetchSubjects();
  }, [currentCourse.id]);

// Запрос на получение списка преподавателей
useEffect(() => {
  const fetchTeachers = async () => {
    try {
      const {data} = await $host('/api/admin/users/role/teacher');
      if (data.message === "succses") {
        setTeachers(data.body); // Сохраняем массив преподавателей в состоянии
      } else {
        console.error("Ошибка при получении данных:", data.message);
      }
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
    }
  };
  fetchTeachers(); // Вызываем функцию для получения преподавателей
}, []);

  // Оберните функцию в useCallback
  const fetchCourseData = useCallback(async (courseId) => {
    try {
      const {data} = await $host(`/api/public/courses/${courseId}`);
      
      setCurrentCourse(data);
      const selected = teachers.find(teacher => teacher.id === data.teacher_id);
      setSelectedTeacher(selected); // Устанавливаем преподавателя
      setSelectedStudents(data.students || []); // Устанавливаем студентов
    } catch (error) {
      console.error("Ошибка при загрузке курса:", error);
    }
  }, [teachers]); // teachers как зависимость

  useEffect(() => {
    if (id) {
      fetchCourseData(id);
    }
  }, [id, fetchCourseData]); // Добавляем fetchCourseData в зависимости
  

  useEffect(() => {
    // Фильтрация преподавателей на основе значения searchTerm
    const filtered = (teachers || []).filter(teacher =>
      teacher.email.toLowerCase().includes(searchTerm.toLowerCase()) || 
      teacher.id.toString().includes(searchTerm) // Фильтрация по ID
    );
    setFilteredTeachers(filtered);
  }, [searchTerm, teachers]);

  const handlePriceApply = () => {
    const priceValue = parseFloat(currentCourse.price);
    if (isNaN(priceValue) || priceValue <= 0) {
      setErrors(prev => ({ ...prev, price: 'Введите корректную цену' }));
      return;
    }
    setIsPriceApplied(true);
  };

  const [curators, setCurators] = useState([]); // Состояние для списка кураторов
  const [selectedCurators, setSelectedCurators] = useState([]); // Состояние для выбранных кураторов
  const [isCuratorModalOpen, setIsCuratorModalOpen] = useState(false); // Состояние для модального окна кураторов
  const [curatorSearchTerm, setCuratorSearchTerm] = useState(''); // Состояние для поиска кураторов
    // Фильтр для кураторов
    const filteredCurators = curators.filter(curator =>
      curator.id.includes(curatorSearchTerm) || curator.email.toLowerCase().includes(curatorSearchTerm.toLowerCase())
    );
  
    // Функция для добавления/удаления куратора из списка выбранных
    const toggleCuratorSelection = (curator) => {
      setSelectedCurators((prev) => {
        if (prev.includes(curator)) {
          return prev.filter(c => c !== curator); // Удаляем куратора
        }
        return [...prev, curator]; // Добавляем куратора
      });
    };
  
    // Удаление всех кураторов
    const removeAllCurators = () => {
      setSelectedCurators([]);
    };

    // Запрос на получение списка кураторов
    useEffect(() => {
      const fetchCurators = async () => {
        try {
          const response = await $host.get('/api/admin/users/role/curator');
          const { data } = response
          if (data.message === "succses") {
            setCurators(data.body); // Сохраняем массив кураторов в состояние
          } else {
            console.error("Ошибка при получении данных:", data.message);
          }
        } catch (error) {
          console.error("Ошибка при загрузке данных:", error);
        }
      };
      fetchCurators();
    }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({ title: '', description: '', subject: '', image: '', teacher: '', price: '' });
    let hasErrors = false;
    
    if (!currentCourse.title) {
      setErrors(prev => ({ ...prev, title: 'Название курса обязательно' }));
      hasErrors = true;
    }

    if (!currentCourse.price) {
      setErrors(prev => ({ ...prev, price: 'Цена обязательна' }));
      hasErrors = true;
    }

    if (!currentCourse.description) {
      setErrors(prev => ({ ...prev, description: 'Описание курса обязательно' }));
      hasErrors = true;
    }
    if (!imageFile && !currentCourse.image_url) {
      setErrors(prev => ({ ...prev, image: 'Обложка обязательна для загрузки' }));
      hasErrors = true;
    }

    if (hasErrors) return;

    const apiUrl = `/api/admin/courses/${id}`;
    const formData = new FormData();
    formData.append('title', currentCourse.title);
    formData.append('description', currentCourse.description);
    formData.append('price', currentCourse.price);
    formData.append('video', videoFile);
    formData.append('teacher_id', selectedTeacher ? selectedTeacher.id : '');
    formData.append('class_course', currentCourse.class_course)

    if (imageFile) formData.append('image', imageFile);
    if (videoFile) formData.append('video', videoFile);

    try {
      await $host.request(apiUrl, {
        method: 'PUT',
        data: formData,
      });
      navigate('/admin/courses');
    } catch (error) {
      console.error(error);
    }
  };

  const formatFileSize = (size) => (size / (1024 * 1024)).toFixed(2) + ' МБ';
  const getFileExtension = (fileName) => fileName.split('.').pop().toUpperCase();




  const [students, setStudents] = useState([]); // Состояние для списка студентов
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false); // Состояние для управления модальным окном
  const [studentSearchTerm, setStudentSearchTerm] = useState('');
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
 
// Обновляем filteredStudents при открытии модального окна
useEffect(() => {
  if (isStudentModalOpen) {
    setFilteredStudents(students || []); // Добавьте проверку здесь
    setStudentSearchTerm('');
  }
}, [isStudentModalOpen, students]);

// Фильтрация студентов
const filteredStudentsList = (students || []).filter(student =>
  student.email.toLowerCase().includes(studentSearchTerm.toLowerCase()) ||
  student.id.toString().includes(studentSearchTerm)
);

// Обработчик изменения для поля ввода
const handleStudentSearch = (e) => {
  setStudentSearchTerm(e.target.value);
  // Обновляем отфильтрованный список студентов
  setFilteredStudents(filteredStudentsList);
};

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const {data} = await $host.get('/api/admin/users/role/student');
        if (data.message === "succses") {
          setStudents(data.body);
        } else {
          console.error("Ошибка при получении данных:", data.message);
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      }
    };
    fetchStudents(); // Вызываем функцию для получения студентов
  }, []);

  const toggleStudentSelection = (student) => {
    if (selectedStudents.includes(student.id)) {
      setSelectedStudents(selectedStudents.filter(id => id !== student.id));
      removeStudentFromCourse(student.id); // Функция для удаления студента
    } else {
      setSelectedStudents([...selectedStudents, student.id]);
      addStudentToCourse(student.id); // Функция для добавления студента
    }
  };
  
  const addStudentToCourse = async (studentId) => {
    try {
      const data = {
        "course_id": currentCourse.id,
        "months": 1,
        "student_id": studentId
      }
      await $host.post('/api/admin/courses/give', data);
      if (currentCourse.id) {
        fetchCourseData(currentCourse.id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const removeStudentFromCourse = async (studentId) => {
    try {
      const data = {
        subscription_id: currentCourse.id,
        student_id: studentId
      }
      await $host.post('/api/admin/courses/remove', data);
      if (id) {
        fetchCourseData(id);
      }
    } catch (error) {
      console.error(error);
    }
  };
  
  const removeAllStudents = () => {
    selectedStudents.forEach(studentId => {
      console.log('selectedStudents', selectedStudents)
      removeStudentFromCourse(studentId);
    });
    setSelectedStudents([]);
  };
  



  return (
    <div>
      <Header />
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <main className="flex-1 p-8 bg-[#F3F1FB4D]">
          <nav className="w-full rounded-md mb-8">
            <ol className="list-reset flex items-center">
              <li>
                <Link to="/admin/courses" className="text-[black]">Главная</Link>
              </li>
              <li className="mx-2">
                <span className="text-neutral-400">&gt;</span>
              </li>
              <li>
                <span className="text-neutral-400">{currentCourse.title}</span>
              </li>
            </ol>
          </nav>
          <h2 className="text-[42px] font-medium mb-4">Редактирование курса</h2>
          <div className="bg-white p-6 rounded-lg shadow-md mb-4" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
            <form onSubmit={handleSubmit}>
              
              {/* Название курса */}
              <div className="mb-8" style={{ border: '1.5px solid #6446C314', borderRadius: '10px', padding: '7px' }}>
                <div className="mb-4 flex items-center justify-between">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="title" style={{ color: '#363645', fontSize: '24px' }}>Название курса
                  <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                  </label>
                  <button type="submit" className="h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px]">Сохранить изменения</button>
                </div>
                <input type="text" id="title" value={currentCourse.title} onChange={(e) => setCurrentCourse({ ...currentCourse, title: e.target.value })} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2" style={{ backgroundColor: '#6446C314', borderRadius: '8px' }} placeholder="Введите название курса" />
                {errors.title && <span className="text-red-500 text-[16px]">{errors.title}</span>}
              </div>

              {/* Описание курса */}
              <div className="mb-8" style={{ border: '1.5px solid #6446C314', borderRadius: '10px', padding: '7px' }}>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description" style={{ color: '#363645', fontSize: '24px' }}>Описание курса
                <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                </label>
                <textarea id="description" value={currentCourse.description} onChange={(e) => setCurrentCourse({ ...currentCourse, description: e.target.value })} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2" placeholder="Введите описание курса" style={{ backgroundColor: '#6446C314', height: '140px', borderRadius: '8px' }} />
                {errors.description && <span className="text-red-500 text-[16px]">{errors.description}</span>}
              </div>
              
              {/* Изображение обложки */}
              <div className="flex items-center mb-2" style={{ border: '1.5px solid #6446C314', borderRadius: '10px', padding: '7px' }}>
                {imageFile || currentCourse.image_url ? (
                  <div className="flex items-center mr-2">
                    <LuUpload style={{ color: '#6446C3', fontSize: '24px', marginRight: '8px' }} />
                    <div>
                      {imageFile ? (
                        <div className="text-[#6446C399] font-normal" style={{ fontSize: '12px' }}>{getFileExtension(imageFile.name)} - файл, {formatFileSize(imageFile.size)}</div>
                      ) : (
                        <img 
                        src={currentCourse.image_url} 
                        alt="Обложка курса" 
                        className="w-10 h-10 object-cover" 
                        style={{ border: '1px dashed gray', borderRadius: '4px' }} 
                        />
                      )}
                    </div>
                    <button onClick={() => { setImageFile(null); setCurrentCourse({ ...currentCourse, image_url: '' }) }} className="ml-2 text-red-600 hover:text-red-800 focus:outline-none">Удалить</button>
                  </div>
                ) : (
                  <label className="border-2 border-dashed border-[#6446C3] rounded-md py-2 px-4 mr-2 cursor-pointer" style={{ borderRadius: '16px' }}>
                    Загрузить обложку
                    <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} className="hidden" />
                  </label>
                )}
                 {videoFile || currentCourse.video_preview_url ? (
                  <div className="flex items-center mr-2">
                    <LuUpload style={{ color: '#6446C3', fontSize: '24px', marginRight: '8px' }} />
                    <div>
                      {videoFile ? (
                        <div className="text-[#6446C399] font-normal" style={{ fontSize: '12px' }}>{getFileExtension(videoFile.name)} - файл, {formatFileSize(videoFile.size)}</div>
                      ) : (
                        <video className="w-10 h-10 object-cover rounded" controls>
                          <source src={currentCourse.video_preview_url} type="video/mp4" />
                          Ваш браузер не поддерживает воспроизведение видео.
                        </video>
                      )}
                    </div>
                    <button onClick={() => { setVideoFile(null); setCurrentCourse({ ...currentCourse, video_preview_url: '' }) }} className="ml-2 text-red-600 hover:text-red-800 focus:outline-none">Удалить</button>
                  </div>
                ) : (
                  <label className="border-2 border-dashed border-[#6446C3] rounded-md py-2 px-4 cursor-pointer ml-4" style={{ borderRadius: '16px' }}>
                    Загрузить видео
                    <input type="file" accept="video/*" onChange={(e) => setVideoFile(e.target.files[0])} className="hidden" />
                  </label>
                )}
              </div>
              {errors.image && <span className="text-red-500 text-[16px]">{errors.image}</span>}
             
              <div className="mt-8 mb-4 flex flex-col"
    style={{
      border: '1.5px solid #6446C314',
      borderRadius: '10px',
      padding: '7px' // Добавлены внутренние отступы
    }}
    >

    <label 
        className="block text-gray-700 text-sm font-bold mb-2"
          style={{
            color: '#363645',
            fontSize: '24px',
            marginRight: '8px',
          }}
        >Предмет
                            <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}

        </label>


<table className="w-3/5 bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden">
        <thead
          style={{ borderBottom: "1px solid #D1D5DB", color: "#6446C3" }}
        >
          <tr>
            <th className="border px-4 py-2 text-left">Название</th>
            <th className="border px-4 py-2 text-left">ID</th>
          </tr>
        </thead>
        <tbody>
         
        {subject ? (
  <tr
    key={subject.id}
    className="cursor-pointer hover:bg-gray-200"
  >
    <td className="border px-4 py-2 text-left">{subject.title}</td>
    <td className="border px-4 py-2 text-left">{subject.id}</td>
  </tr>
) : (
  <tr>
    <td className="border px-4 py-2" colSpan={3}>
      Нет предметов
    </td>
  </tr>
)}
        </tbody>
      </table>
</div> 


             {/* Блок для редактирования преподавателя */}
<div className="mt-8 mb-4 flex flex-col" style={{ border: '1.5px solid #6446C314', borderRadius: '10px', padding: '7px' }}>
  <label className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px', marginRight: '8px' }}>Преподаватель:
  <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}

  </label>
  <table className="w-3/5 bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden mb-4">
        <thead
          style={{ borderBottom: "1px solid #D1D5DB", color: "#6446C3" }}
        >
          <tr>
            <th className="border px-4 py-2 text-left">Email</th>
            <th className="border px-4 py-2 text-left">ID</th>
          </tr>
        </thead>
        <tbody>
         
        {selectedTeacher ? (
  <tr
    key={selectedTeacher.id}
    className="cursor-pointer hover:bg-gray-200"
  >
    <td className="border px-4 py-2 text-left">{selectedTeacher.email}</td>
    <td className="border px-4 py-2 text-left">{selectedTeacher.id}</td>
  </tr>
) : (
  <tr>
    <td className="border px-4 py-2" colSpan={3}>
      Нет преподавателей
    </td>
  </tr>
)}
        </tbody>
      </table>






  <button
    type="button"
    className="max-w-[230px] h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px] mb-2"
    onClick={() => setTeacherIsModalOpen(true)}
  >
    Поменять преподавателя
  </button>
  {errors.teacher && <span className="text-red-500 text-[16px]">{errors.teacher}</span>} 
</div>

{isTeacherModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-lg p-8 w-[60%] relative">
      <h2 className="text-lg font-bold mb-4">Выбор преподавателя</h2>
      <button 
        onClick={() => setTeacherIsModalOpen(false)} 
        className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
      >
        <AiOutlineClose size={24} />
      </button>

      <div className="relative">
        <FaSearch
          className="weight-900 absolute left-3 top-2.5 text-[#6446C399]"
          size={20}
        />
        <input
          type="text"
          placeholder="Введите email или ID преподавателя"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border rounded-[16px] p-2 w-full pl-10 mb-4"
          style={{
            backgroundColor: '#6446C314',
            color: '#6446C399',
          }}
        />
      </div>
      <div className="mb-2">
        <span className="text-gray-500 ml-1">*</span>
        <label className="font-normal text-gray-500">Выберите преподавателя с помощью двойного клика:</label>
      </div>
      <div className="overflow-auto max-h-[40vh]"> {/* Контейнер с фиксированной высотой и прокруткой */}
      <table className="min-w-full bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden">
        <thead style={{ borderBottom: '1px solid #D1D5DB', color: '#6446C3' }}>
          <tr>
            <th className="border px-4 py-2 text-left">№</th>
            <th className="border px-4 py-2 text-left">Email</th>
            <th className="border px-4 py-2 text-left">ID</th>
          </tr>
        </thead>
        <tbody>
          {filteredTeachers.length > 0 ? (
            filteredTeachers
              .filter(teacher => teacher.id !== selectedTeacher?.id) // Фильтруем текущего преподавателя
              .map((teacher, index) => (
                <tr key={teacher.id} onDoubleClick={() => handleTeacherSelection(teacher)} className="cursor-pointer hover:bg-gray-200">
                  <td className="border px-4 py-2 text-left">{index + 1}</td>
                  <td className="border px-4 py-2 text-left">{teacher.email}</td>
                  <td className="border px-4 py-2 text-left">{teacher.id}</td>
                </tr>
              ))
          ) : (
            <tr>
              <td className="border px-4 py-2" colSpan={3}>Нет преподавателей</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    </div>
  </div>
)}

{/* Наставничество */}
<div className="mt-8 mb-2 flex flex-col border border-[#6446C314] rounded-[10px] p-2">
                <span className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px' }}>
                  Наставничество:
                </span>
                <div className="flex items-center">
                  {selectedCurators.length > 0 && <span className="text-[#6446C3] font-normal mr-4">{selectedCurators.length} наставников</span>}
                  <button type="button" className="max-w-[230px] h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px]" onClick={() => setIsCuratorModalOpen(true)}>
                    Настроить
                  </button>
                </div>
              </div>

              {/* Модальное окно для выбора кураторов */}
              {isCuratorModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                  <div className="bg-white rounded-lg p-8 w-[60%] relative">
                    <h2 className="text-lg font-bold mb-4">Выбор кураторов</h2>
                    <button onClick={() => setIsCuratorModalOpen(false)} className="absolute top-4 right-4 text-gray-600 hover:text-gray-800">
                      <AiOutlineClose size={24} />
                    </button>
                    <div className="relative mb-4">
                      <FaSearch className="weight-900 absolute left-3 top-2.5 text-[#6446C399]" size={20} />
                      <input
                        type="text"
                        placeholder="Введите email, ФИО или ID наставника"
                        value={curatorSearchTerm}
                        onChange={(e) => setCuratorSearchTerm(e.target.value)}
                        className="border rounded-[16px] p-2 w-full pl-10 mb-4"
                        style={{ backgroundColor: '#6446C314', color: '#6446C399' }}
                      />
                    </div>
                    <div className="overflow-auto max-h-[40vh]"> {/* Контейнер с фиксированной высотой и прокруткой */}
                      <table className="min-w-full bg-[#F3F1FB] border shadow-md rounded-[16px] overflow-hidden">
                        <thead style={{ borderBottom: '1px solid #D1D5DB', color: '#6446C3' }}>
                          <tr>
                            <th className="border px-4 py-2 text-left">№</th>
                            <th className="border px-4 py-2 text-left">Email</th>
                            <th className="border px-4 py-2 text-left">ID</th>
                            <th className="border px-4 py-2 text-left"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredCurators.length > 0 ? (
                            filteredCurators.map((curator, index) => (
                              <tr key={curator.id} className="hover:bg-gray-200">
                                <td className="border px-4 py-2 text-left">{index + 1}</td>
                                <td className="border px-4 py-2 text-left">{curator.email}</td>
                                <td className="border px-4 py-2 text-left">{curator.id}</td>
                                <td className="border px-4 py-2 text-left">
                                  <button
                                    type="button"
                                    onClick={() => toggleCuratorSelection(curator)}
                                    className={`py-2 px-4 rounded-[8px] ${selectedCurators.includes(curator) ? 'bg-[#6446C314] text-[#6446C3]' : 'bg-[#6446C3] text-white'} transition duration-200 ease-in-out hover:bg-[#6446C314] text-[12px] font-normal`}
                                  >
                                    {selectedCurators.includes(curator) ? 'Отмена' : 'Добавить'}
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="border px-4 py-2" colSpan={4}>Нет кураторов</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="flex mt-4">
                      <button type="button" onClick={removeAllCurators} className="rounded-[10px] bg-red-500 text-white p-2">Удалить всех</button>
                    </div>
                  </div>
                </div>
              )}


              {/* Цена курса */}
              <div className="mt-8 mb-2 flex flex-col" style={{ border: '1.5px solid #6446C314', borderRadius: '10px', padding: '7px' }}>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="price" style={{ color: '#363645', fontSize: '24px' }}>Цена курса
                <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                </label>
                <div className="relative">
                  <div className="flex items-center mb-2">
                    <input 
                    type="text" 
                    id="price" 
                    value={currentCourse.price} 
                    onChange={(e) => setCurrentCourse({ ...currentCourse, price: e.target.value })} 
                    className="bg-[#6446C314] border-b border-[#6446C3] outline-none rounded-[12px] w-full max-w-[350px] h-[42px] pl-4 pr-16 text-[#6446C3]" 
                    placeholder="Введите цену курса" 
                    />
                    <button type="button" onClick={handlePriceApply} className={`bg-[#6446C3] text-white rounded-[8px] px-2 py-2 h-[32px] ml-[-110px] ${isPriceApplied ? 'bg-gray-400 text-gray-200' : 'bg-[#6446C3] text-white'}`} disabled={isPriceApplied}>Применить</button>
                  </div>
                  {errors.price && <span className="mt-2 text-red-500 text-[16px]">{errors.price}</span>}
                </div>
              </div>

            </form>

{isStudentModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-lg p-8 w-[60%] relative">
      <h2 className="text-lg font-bold mb-4">Выбор студентов</h2>
      <button 
        onClick={() => setIsStudentModalOpen(false)} 
        className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
      >
        <AiOutlineClose size={24} />
      </button>

      <div className="relative">
  <FaSearch
    className="weight-900 absolute left-3 top-2.5 text-[#6446C399]"
    size={20}
  />
  <input
    type="text"
    placeholder="Введите email или ID студента"
    value={studentSearchTerm}
    onChange={handleStudentSearch} // Используем новый обработчик
    className="border rounded-[16px] p-2 w-full pl-10 mb-4"
    style={{
      backgroundColor: '#6446C314',
      color: '#6446C399',
    }}
  />
</div>

<div className="overflow-auto h-[40vh]"> {/* Контейнер с фиксированной высотой и прокруткой */}

  <table className="min-w-full bg-[#F3F1FB] border shadow-md rounded-[16px]">
    <thead style={{ borderBottom: '1px solid #D1D5DB', color: '#6446C3' }}>
      <tr>
        <th className="border px-4 py-2 text-left">№</th>
        <th className="border px-4 py-2 text-left">Email</th>
        <th className="border px-4 py-2 text-left">ID</th>
        <th className="border px-4 py-2 text-left"></th>
      </tr>
    </thead>
    <tbody>
      {filteredStudents.length > 0 ? (
        filteredStudents.map((student, index) => (
          <tr key={student.id} className="hover:bg-gray-200">
            <td className="border px-4 py-2 text-left">{index + 1}</td>
            <td className="border px-4 py-2 text-left">{student.email}</td>
            <td className="border px-4 py-2 text-left">{student.id}</td>
            <td className="border px-4 py-2 text-left">
              <button 
                type="button"
                onClick={() => toggleStudentSelection(student)} 
                className={`py-2 px-4 rounded-[8px] ${selectedStudents.includes(student.id) ? 'bg-[#6446C314] text-[#6446C3]' : 'bg-[#6446C3] text-white'} transition duration-200 ease-in-out hover:bg-[#6446C314] text-[12px] font-normal`}
              >
                {selectedStudents.includes(student.id) ? 'Удалить' : 'Добавить'}
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td className="border px-4 py-2" colSpan={4}>Нет студентов</td>
        </tr>
      )}
    </tbody>
  </table>
</div>

      <div className="flex mt-4">
        <button type="button" onClick={removeAllStudents} className="rounded-[10px] bg-red-500 text-white p-2">Удалить всех</button>
      </div>
    </div>
  </div>
)}


          </div>

          <div className="bg-white p-6 rounded-lg shadow-md mb-4" style={{ maxHeight: '15vh', overflowY: 'auto' }}>
          <div className="mb-4 flex flex-col" style={{ border: '1.5px solid #6446C314', borderRadius: '10px', padding: '7px' }}>
  <span className="block text-gray-700 text-sm font-bold mb-2" style={{ color: '#363645', fontSize: '24px' }}>
    Студенты:
  </span>
  <div className="flex items-center">
    {currentCourse.students && currentCourse.students.length > 0 && (
      <span className="text-[#6446C3] font-normal mr-4">
        {currentCourse.students.length} студент{currentCourse.students.length > 1 ? 'а' : ''}
      </span>
    )}
    <button
      type="button"
      className="max-w-[230px] h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px]"
      onClick={() => setIsStudentModalOpen(true)}
    >
      Настроить студентов
    </button>
  </div>
</div>
          </div>

        </main>
      </div>
    </div>
  );
};

export default CourseEditPage;
